//Utility Packages
import { Dialog } from 'primereact/dialog';
import { classNames } from 'primereact/utils';
import { useSelector } from 'react-redux';

const JobDetailsRow = (props) => {
  return (
    <div className="detail-row">
      <p className="title">
        <span>{props.title}</span>
        <span className="colon">:</span>
      </p>
      <div className="content">
        <span>{props.value}</span>
      </div>
    </div>
  );
};

const ViewJobDetails = (props) => {
  const { data, header, onHide, show } = props;
  const { isLoading } = useSelector((state) => state.apiStatus);
  return (
    <Dialog
      header={header}
      className={classNames('card overflow-hidden resize-none person-details-popup', {
        hidden: isLoading
      })}
      visible={show}
      onHide={onHide}>
      {data?.map((item, i) => {
        if (item.title !== 'Description') {
          return (
            <JobDetailsRow key={i} title={item.title} value={item.value ? item.value : '--'} />
          );
        }
        return null;
      })}
      <div
        className="m-0"
        dangerouslySetInnerHTML={{
          __html: data?.find((item) => item.title === 'Description')?.value || ''
        }}
      />
    </Dialog>
  );
};

export default ViewJobDetails;
